import { combineReducers } from "redux";
import repositoriesReducer from './repositoriesReducer';
import nominationsReducer from "./nominationsReducer";
const reducers = combineReducers({
    repositories: repositoriesReducer,
    nominations: nominationsReducer,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;